import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '@src/redux/store'
import { prop } from 'ramda'

import {
  AUTH_LOGIN,
  CONFERENCE_AUTHOR_PROFILE,
  CONFERENCE_SIGN_UP,
  EMAIL_SEND,
  SMS_SEND,
  TOKEN,
  USER_INFO,
  VERIFY_EMAIL,
} from '../constants/actionTypes'
import { AUTH } from './reducer'

export const authSelector = (state: RootState) => prop(AUTH, state)

// OLD CODE (kept commented for reference)
// export const authToken = createSelector(authSelector, (state: ReturnType<typeof authSelector>) => state[TOKEN])
// export const authUserInfo = createSelector(authSelector, (state: ReturnType<typeof authSelector>) => state[USER_INFO])
// export const authLogin = createSelector(authSelector, (state: ReturnType<typeof authSelector>) => state[AUTH_LOGIN])
// export const authSignUp = createSelector(authSelector, (state: ReturnType<typeof authSelector>) => state[SIGN_UP])
// export const smsSend = createSelector(authSelector, (state: ReturnType<typeof authSelector>) => state[SMS_SEND])
// export const emailVerify = createSelector(authSelector, (state: ReturnType<typeof authSelector>) => state[VERIFY_EMAIL])

const defaultAsyncState = { loading: false, error: null, data: null }

export const authToken = createSelector(authSelector, state => state?.[TOKEN])

export const authUserInfo = createSelector(authSelector, state => state?.[USER_INFO])

export const institutionSelector = createSelector(
  authSelector,
  // selected => selected?.userInfo?.selected_institution?.value
  selected => selected?.userInfo?.id
)

export const rolesMapSelector = createSelector(authUserInfo, selected => selected?.roles_map)

export const rolesSelector = createSelector(authUserInfo, selected => selected?.roles)

export const conferenceAuthLogin = createSelector(authSelector, state => state?.[AUTH_LOGIN] ?? null)

export const conferenceAuthSignUp = createSelector(
  authSelector,
  state => state?.[CONFERENCE_SIGN_UP] ?? defaultAsyncState
)

export const authConferenceAuthorProfile = createSelector(
  authSelector,
  state => state?.[CONFERENCE_AUTHOR_PROFILE] ?? defaultAsyncState
)

export const smsSend = createSelector(authSelector, state => state?.[SMS_SEND] ?? defaultAsyncState)

export const emailSend = createSelector(authSelector, state => state?.[EMAIL_SEND] ?? defaultAsyncState)

export const emailVerify = createSelector(authSelector, state => state?.[VERIFY_EMAIL] ?? defaultAsyncState)
